import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  OnChanges,
  SimpleChanges
} from '@angular/core';
import { LocalStorageHelpers } from 'app/helpers';

@Component({
  selector: 'app-year-filter',
  templateUrl: './app-year-filter.component.html',
  styleUrls: ['./app-year-filter.component.scss']
})
export class AppYearFilterComponent implements OnInit, OnChanges {
  @Input() start = 2010;
  @Input() end: number = null;
  @Input() all = 'ALL';
  @Input() disabled = false;
  @Output() onClick: EventEmitter<number> = new EventEmitter<number>();

  private _currentYear = new Date().getFullYear();
  private _selectedYear: number = null;

  public avoidClick = false;

  public years: {
    key: string | number;
    value: string | number;
    active: boolean;
  }[] = [];

  constructor(private localStorageHelpers: LocalStorageHelpers) {
    const userData = JSON.parse(this.localStorageHelpers.get('userData'));
    this.start = new Date(userData['Profile']['created_at']).getFullYear();
  }

  ngOnInit() {
    this.onClick.emit(this._currentYear);
    this._selectedYear = this._currentYear;

    if (this.end === null) {
      this.end = this._currentYear;
    }

    for (let i = this.start; i <= this.end; i++) {
      this.years.push({
        key: i,
        value: i,
        active: i === this._selectedYear
      });
    }

    // ALL button
    // this.years.push({
    //   key: null,
    //   value: this.all,
    //   active: true
    // });

    this.years.reverse();
  }

  ngOnChanges(changes: SimpleChanges) {
    this.avoidClick = changes.disabled.currentValue;
  }

  public emitter($event: number): void {
    this.onClick.emit($event);
    this._selectedYear = $event;
    this.years.forEach(year => {
      year.active = year.key === this._selectedYear;
    });
  }
}
